import * as React from 'react';
import { useState } from 'react';
import { Question, timestampDescription } from '../Types/Question';
import { Advisor, advisorProfilePath } from '../Types/Advisor';
import { formatMultiParagraphString, htmlIf, maybeHtml } from '../Utils/HTML';
import { timeAgo } from '../Utils/DateTime';
import { AdvisorCardCta, EssayHelpCta, FindAnAdvisorCta } from './QuestionCtas';

type Props =
  { question: Question
  , advisor?: Advisor
  , isAdmin: boolean
  }

const QuestionPage = (props: Props) => {
  return (
    <div className="row">
      <div className="col-lg-8">
        <div className="card rounded-1">
          <div className="card-body p-3">
            <h1 className="h3 mb-2">{props.question.title}</h1>
            <div className="fs-md text-gray-900 mb-2">{formatMultiParagraphString(props.question.fullQuestion)}</div>
            <div className="d-flex align-items-center">
              <div className="fs-md text-gray-700" title={timestampDescription(props.question)}>{timeAgo(new Date(props.question.timestamp))}</div>
              <div className=""> • </div>
              <div>{props.question.numViews} view{props.question.numViews === 1 ? '' : 's'}</div>
            </div>
            {/* <div className="mt-2">Share button</div> */}
          </div>
        </div>

        <div className="card rounded-1 mt-3">
          <div className="card-body p-3 d-flex">
            <div className="me-2">
              <div className="avatar avatar-lg">
                { props.question.attributeAnswerToAdvisor && props.advisor
                ? <a className="text-decoration-none" href={advisorProfilePath(props.advisor)}>
                    <img className="avatar-img rounded-circle" src={props.advisor?.imageUrl} />
                  </a>
                : <div className="avatar-title rounded-circle bg-gray-300">
                    <i className="ai-user h1 mb-0" />
                  </div>
                }
              </div>
            </div>
            <div className="">
              {maybeHtml(props.advisor, (advisor) => (
                <div className="d-flex align-items-center">
                  { props.question.attributeAnswerToAdvisor
                  ? <a className="fs-lg fw-bold text-dark text-decoration-none" href={advisorProfilePath(advisor)}>
                      {props.advisor.preferredName}
                    </a>
                  : <div className="fs-lg fw-bold">Anonymous</div>
                  }
                  <div className="text-gray-700" title={timestampDescription(props.question)}> • {timeAgo(new Date(props.question.timestamp))}</div>
                </div>
              ))}
              {htmlIf(!props.advisor,
                <>
                  <div className="fs-lg fw-bold">Anonymous</div>
                  <div className="text-gray-700" title={timestampDescription(props.question)}>{timeAgo(new Date(props.question.timestamp))}</div>
                </>
              )}
              {maybeHtml(props.advisor, (advisor) => (
                <div className="mt-1">
                  { props.question.attributeAnswerToAdvisor
                  ? 'Advisor'
                  : <div className="d-flex">
                      <div className="avatar avatar-24 me-1">
                        <div className="avatar-title rounded-circle bg-success">
                          <i className="ai-check text-white fs-md" />
                        </div>
                      </div>
                      <div>
                        Verified by Advisor 
                        <a className="fw-bold text-dark" href={advisorProfilePath(advisor)}>{advisor.preferredName}</a>
                      </div>

                    </div>
                  }
                </div>
              ))}
              <div className="fs-md text-gray-900 mt-1">{formatMultiParagraphString(props.question.answer)}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="col col-lg-4 mt-3 mt-lg-0">
        { props.advisor && props.advisor?.isOpenToWork
        ? AdvisorCardCta(props.advisor)
        : props.question.title.toLowerCase().includes("essay")
          ? <EssayHelpCta />
          : <FindAnAdvisorCta />
        }
      </div>
    </div>
  )
}

export default QuestionPage;
